var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-verificaMsg" },
    [
      _c("CheckInput", {
        staticClass: "veriific-input",
        attrs: { type: "vecifi", label: "验证码" },
        on: { input: _vm.handleInputMsg },
        model: {
          value: _vm.value,
          callback: function($$v) {
            _vm.value = $$v
          },
          expression: "value"
        }
      }),
      _c(
        "Button",
        {
          staticClass: "veriific-btn",
          attrs: { skin: "grey", disabled: _vm.isCountDown ? true : false },
          on: { click: _vm.sendMsgHandler }
        },
        [_vm._v(_vm._s(_vm.isCountDown ? _vm.time + "s" : "发送验证码"))]
      ),
      _vm.modal
        ? _c(
            "Modal",
            {
              attrs: { overlay: _vm.opaque },
              on: { close: _vm.closePostHandler }
            },
            [
              _c(
                "Card",
                { staticClass: "content-card" },
                [
                  _c("div", [_vm._v(_vm._s(_vm.verificationMsg) + " =")]),
                  _c("CheckInput", {
                    staticClass: "card-input",
                    attrs: {
                      placeholder: "",
                      label: "?",
                      type: "Number",
                      startVerific: true
                    },
                    on: { blur: _vm.handleInputBlur },
                    model: {
                      value: _vm.verificationAnswer,
                      callback: function($$v) {
                        _vm.verificationAnswer = $$v
                      },
                      expression: "verificationAnswer"
                    }
                  }),
                  _c(
                    "Button",
                    {
                      staticClass: "card-btn",
                      attrs: { skin: "red" },
                      on: { click: _vm.handleSubmitAnswer }
                    },
                    [_vm._v(" 确认 ")]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }